import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { apiGet } from '@/lib/api';

const CatalogContext = createContext(null);

/** Produktkatalog fra backend (produkter, kategorier, leveringsmåter). Hentes én gang per økt. */
export function CatalogProvider({ children }) {
  const [state, setState] = useState({ status: 'loading', products: [], categories: [], deliveryMethods: [], error: null });

  const load = useCallback(async () => {
    setState((s) => ({ ...s, status: 'loading', error: null }));
    try {
      const data = await apiGet('/products');
      setState({ status: 'ready', products: data.products ?? [], categories: data.categories ?? [], deliveryMethods: data.deliveryMethods ?? [], error: null });
    } catch (e) {
      setState((s) => ({ ...s, status: 'error', error: e.message || 'Kunne ikke hente produkter' }));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const value = useMemo(() => {
    const bySlug = Object.fromEntries(state.products.map((p) => [p.slug, p]));
    return { ...state, bySlug, reload: load, ready: state.status === 'ready' };
  }, [state, load]);

  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
}

export function useCatalog() {
  const ctx = useContext(CatalogContext);
  if (!ctx) throw new Error('useCatalog utenfor CatalogProvider');
  return ctx;
}
